import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";
import PanelMappingService from "../../../../Services/InfectiousDisease/PanelMappingService";
import { getFacilitiesLookup } from "../../../../Services/Marketing/BulletinBoardService";
import { SAlesRepLookupApi } from "../../../../Services/Marketing/TrainingAids";
import {
  GenerateReportV2,
  RequisitionReportSave,
} from "../../../../Services/Requisition/RequisitionReports/RequisitionReport";
import RequisitionType from "../../../../Services/Requisition/RequisitionTypeService";
import { SalesGroupGetAll } from "../../../../Services/SalesGroup/SalesGroup";
import DateAndTimeDuplicate from "../../../../Shared/Common/DatePicker/DateAndTime";
import { reactSelectSMStyle, styles } from "../../../../Utils/Common";
import {
  convertBrowserDateTimeToUtc,
  convertLabDateTimeToUtc,
  formatUtcTimeForApi,
} from "../../../../Utils/Common/LabTimeZone";
import { markReportQueued } from "../../../../Utils/Common/QueuedReportTracker";
import {
  pushReportNotice,
  updateReportNotice,
} from "../../../../Utils/Common/ReportNotifier";
import useLang from "./../../../../Shared/hooks/useLanguage";
import BillingReport from "./BillingReport";
import ByFacility from "./ByFacility";
import BySaleRep from "./BySaleRep";
import BySalesGroup from "./BySalesGroup";
import CheckBox from "./CheckBox";
import MonthlyPositively from "./MonthlyPositively";
import ScheduleReportModal, { ScheduleConfig } from "./ScheduleReportModal";
// import StewardReport from "./StewardReport";
import TATReport from "./TATReport";

interface Lookups {
  value: number;
  label: string;
}

interface radioVal {
  label: string;
  value: number;
}

// Reports that send a report name. Every other report keeps sending
// the selected date type as reportType.
const REPORT_TYPE_NAME = {
  RequisitionBillingReport: "Requisition Billing",
  PendingRequisitionReport: "Pending Requisition",
  MircoRequisitionReport: "Micro Requisition",
  BloodCriticalReport: "Blood Critical",
  MicroPercentSensitivitiesReport: "Micro Percent Sensitivities",
  StewardshipReport: "Stewardship Report",
  TestTypeandPositivityAnalysisReport: "Test Type & Positivity Analysis Report",
  DelayTrendsReport: "Delay Trends Report"
} as const;

// radioValues reportBy of the reports that carry their own reportType
const REQUISITION_BILLING = 7;
const PENDING_REQUISITION_LIST = 10;
const MICRO_PERCENT_SENSITIVITIES = 11;
const NOT_RECEIVED_REPORT = 22;


const POSITIVE_NEGATIVE_REPORT = 15;
const DAILY_SAMPLE_VOLUME_REPORT = 16; 
const Processed_Samples_Report = 19;
const TEST_TYPE_POSITIVITY = 17;
const DELAY_TRENDS = 18;
const TAT_TURNAROUND_TIME_REPORT = 20;
const IGNITEABX_REPORT_EXPORT = 21;

const REPORT_BY_TO_REPORT_TYPE: Record<number, string | undefined> = {
  [REQUISITION_BILLING]: REPORT_TYPE_NAME.RequisitionBillingReport,
  8: REPORT_TYPE_NAME.MircoRequisitionReport,
  9: REPORT_TYPE_NAME.BloodCriticalReport,
  14: REPORT_TYPE_NAME.StewardshipReport,
  [PENDING_REQUISITION_LIST]: REPORT_TYPE_NAME.PendingRequisitionReport,
  [MICRO_PERCENT_SENSITIVITIES]:
    REPORT_TYPE_NAME.MicroPercentSensitivitiesReport
};

// Reports with fixed columns hide the "Select Data" checkboxes. Type 15
// still sends the selected date type to sp_GetRequisitionReportData.
const hasFixedReportColumns = (reportBy: number | null) =>
  reportBy === POSITIVE_NEGATIVE_REPORT ||
reportBy === TEST_TYPE_POSITIVITY ||
  reportBy === DELAY_TRENDS ||
  reportBy === Processed_Samples_Report ||
  reportBy === DAILY_SAMPLE_VOLUME_REPORT ||
  (reportBy !== null && REPORT_BY_TO_REPORT_TYPE[reportBy] !== undefined);
// Reports the backend builds from a fixed column set — they send their own
// reportType and hide the "Select Data" checkboxes.
const isNamedReport = (reportBy: number | null) =>
  reportBy === DAILY_SAMPLE_VOLUME_REPORT ||
  reportBy !== null && REPORT_BY_TO_REPORT_TYPE[reportBy] !== undefined;

// The queue request answers almost instantly, so the spinner is held back to
// let both steps be read as one ~10 second sequence
const PENDING_NOTICE_MIN_MS = 3000;
const QUEUED_NOTICE_AUTO_CLOSE_MS = 7000;
const ERROR_NOTICE_AUTO_CLOSE_MS = 6000;

const ReqReport = () => {
  const { t } = useLang();
  const labTimeZone = useSelector(
    (state: any) => state?.Reducer?.selectedTenantInfo?.labTimeZone
  );
  const radioValues: radioVal[] = [
    {
      label: t("All Data"),
      value: 0,
    },
    {
      label: t("By Facility"),
      value: 1,
    },
    {
      label: t("By Sales Rep"),
      value: 2,
    },

    {
      label: t("Positive Accession Report"),
      value: 3,
    },

    {
      label: t("By Sales Group"),
      value: 4,
    },
    {
      label: t("Billing Report"),
      value: 5,
    },
    {
      label: t("TAT Report"),
      value: 6,
    },
    // {
    //   label: t("Monthly Stewardship Report"),
    //   value: 7,
    // },
    {
      label: t("Requisition Billing"),
      value: 7,
    },
    {
      label: t("Micro Requisition Listing"),
      value: 8,
    },
    {
      label: t("Critical Test Report"),
      value: 9,
    },
    {
      label: t("Pending Requisition List"),
      value: 10,
    },
    {
      label: t("Microbiology Percent Sensitivities Profile Report"),
      value: 11,
    }, {
      label: t("Test Type & Positivity Analysis Report"),
      value: 17,
    },
    {
      label: t("Positive/Negative Report"),
      value: 15,
    },
    {
      label: t("Monthly Stewardship Report"),
      value: 14
    }
    , {
      label: t("Delay Trends Report"),
      value: 18,
    },
    {
      label: t("Daily Sample Volume Report"),
      value: 16,
    },
    {
      label: t("Processed Samples Report"),
      value: 19,
    },
    {
      label: t("TAT (Turnaround Time) Report"),
      value: TAT_TURNAROUND_TIME_REPORT,
    },
    {
      label: t("IgniteABX Report Export"),
      value: 21,
    },
      {
      label: t("Not Received Report"),
      value: 22,
    },
  ];

  const [showFacility, setShowFacility] = useState(false);
  const [showSaleRep, setShowSaleRep] = useState(false);
  const [monthlyPositively, setMonthlyPositively] = useState(false);
  const [billingReport, setBillingReport] = useState(false);
  const [tatReport, setTATReport] = useState(false);
  // const [stewardReport, setStewardReport] = useState(false);
  const [parentChecked, setParentChecked] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [selectedValue, setSelectedValue] = useState<number | null>(null);

  /*#####################-----Facility states Start-----###################*/

  const [facilityLookup, setFacilityLookup] = useState<Lookups[]>([]);
  const [selectedFacilities, setSelectedFacilities] = useState<Lookups[]>([]);
  const [selectedFacilitiesSearchTerm, setSelectedFacilitiesSearchTerm] =
    useState("");
  const [allFacilitiesSearchTerm, setAllFacilitiesSearchTerm] = useState("");

  /*#####################-----Facility states End-----###################*/
  /*#####################-----Salerep states Start-----###################*/
  const [salesReplookup, setSalesReplookup] = useState<Lookups[]>([]);
  const [selectedSalesRep, setSelectedSalesRep] = useState<Lookups[]>([]);
  const [allRepsSearchTerm, setAllRepsSearchTerm] = useState("");
  const [selectedRepsSearchTerm, setSelectedSalesRepsSearchTerm] = useState("");
  /*#####################-----Salerep states End-----###################*/

  // ###  Date state
  const [filterData, setFilterData] = useState<any>({});
  const [testTypeLookup, setTestTypeLookup] = useState<Lookups[]>([]);
  const [selectedTestType, setSelectedTestType] = useState<Lookups | null>(
    null
  );
  const defaultTestType: Lookups = { value: 0, label: t("Select All") };

  /*############-----Pending Requisition List filters Start-----###########*/
  // Requisition Type reuses the lab's own requisition type lookup (Blood, TOX,
  // ID, Microbiology) behind an "All Requisitions" entry, preselected
  const allRequisitionTypes: Lookups = {
    value: 0,
    label: t("All Requisitions"),
  };
  const requisitionTypeOptions: Lookups[] = [
    allRequisitionTypes,
    ...testTypeLookup.filter((option) => option.value !== 0),
  ];
  // Order Type is the reference lab lookup, with "All Orders" in front of it
  const allOrders: Lookups = { value: 0, label: t("All Orders") };
  const [orderTypeLookup, setOrderTypeLookup] = useState<Lookups[]>([]);
  const orderTypeOptions: Lookups[] = [
    allOrders,
    ...orderTypeLookup.filter((option) => option.value !== 0),
  ];
  const [selectedRequisitionType, setSelectedRequisitionType] =
    useState<Lookups | null>(null);
  const [selectedOrderType, setSelectedOrderType] = useState<Lookups | null>(
    null
  );
  /*############-----Pending Requisition List filters End-----#############*/

  /*######-----Micro Percent Sensitivities filters Start-----##########*/
  // This report is generated for one facility at a time — it becomes the
  // Location in the PDF header — so it uses a single picker instead of the
  // dual list, and the id still travels as facilityIds: [id]
  const [selectedReportFacility, setSelectedReportFacility] =
    useState<Lookups | null>(null);
  /*######-----Micro Percent Sensitivities filters End-----############*/

  // ## CheckBox  State
  const [childChecked, setChildChecked] = useState(Array(42).fill(false));

  const initialPostData = {
    id: 0,
    selectLabel: "",
  };
  const [postData, setpostData] = useState<any>(initialPostData);
  const allClinics: Lookups = {
    value: 0,
    label: "All Clinics",
  };

  const allPanels: Lookups = {
    value: 0,
    label: "All Panels",
  };

  const [selectedClinic, setSelectedClinic] =
    useState<Lookups>(allClinics);

  const [selectedPanel, setSelectedPanel] =
    useState<Lookups>(allPanels);

  const [panelLookup, setPanelLookup] =
    useState<Lookups[]>([]);


  /*#####################-----Facility function Start-----###################*/
  useEffect(() => {
    const fetchFacilities = async () => {
      const facilities = await getFacilitiesLookup();
      setFacilityLookup(facilities.data);
    };
    fetchFacilities();
  }, [selectedValue]);

  useEffect(() => {
    const fetchTestTypes = async () => {
      try {
        const response = await RequisitionType.requisitionTypeLookup();
        const data = response?.data?.data ?? response?.data ?? [];
        const options = [
          defaultTestType,
          ...(Array.isArray(data) ? data : []).map((item: any) => ({
            value: item.value ?? item.reqTypeId,
            label: item.label ?? item.requisitionTypeName,
          })),
        ];
        setTestTypeLookup(options);
      } catch (error) {
        console.error(error);
      }
    };
    fetchTestTypes();
  }, []);

  useEffect(() => {
    const fetchOrderTypes = async () => {
      try {
        const response = await PanelMappingService.PerformingLabLookup();
        const data = response?.data?.data ?? response?.data ?? [];
        setOrderTypeLookup(
          (Array.isArray(data) ? data : []).map((item: any) => ({
            value: item.value ?? item.id,
            label: item.label ?? item.labName ?? item.name,
          }))
        );
      } catch (error) {
        console.error(error);
      }
    };
    fetchOrderTypes();
  }, []);

  const handleFacilityClick = (facility: Lookups) => {
    setSelectedFacilities((prevSelectedFacilities) => {
      if (
        prevSelectedFacilities.some(
          (selected) => selected.value === facility.value
        )
      ) {
        return prevSelectedFacilities;
      } else {
        return [...prevSelectedFacilities, facility];
      }
    });

    setFacilityLookup((prevFacilityLookup) =>
      prevFacilityLookup.filter((f) => f.value !== facility.value)
    );
  };

  const removeSelectedFacilities = (facility: Lookups) => {
    setSelectedFacilities((prevSelectedFacilities) =>
      prevSelectedFacilities.filter((f) => f.value !== facility.value)
    );
    setFacilityLookup((prevFacilityLookup) => [
      ...prevFacilityLookup,
      facility,
    ]);
  };
  const filteredSelectedFacilities = selectedFacilities.filter((facility) =>
    facility?.label
      ?.toLowerCase()
      .includes(selectedFacilitiesSearchTerm.toLowerCase())
  );

  const removeDuplicates = (arr: Lookups[]): Lookups[] => {
    const uniqueValues = new Set<number>();
    return arr.filter((item) => {
      if (uniqueValues.has(item.value)) {
        return false;
      } else {
        uniqueValues.add(item.value);
        return true;
      }
    });
  };
  const uniqueLookup = removeDuplicates(facilityLookup);
  const lookupForEdit = uniqueLookup.filter(
    (lookupItem: Lookups) =>
      !selectedFacilities.some(
        (selectedItem: Lookups) => selectedItem.value === lookupItem.value
      )
  );
  const filteredAllFacilities = lookupForEdit.filter((facility) =>
    facility.label.toLowerCase().includes(allFacilitiesSearchTerm.toLowerCase())
  );
  const moveAllToSelectedFacilities = () => {
    setSelectedFacilities((prevSelectedFacilities) => [
      ...prevSelectedFacilities,
      ...facilityLookup,
    ]);
    setFacilityLookup([]);
  };

  const moveAllToFacilityLookup = () => {
    setFacilityLookup((prevFacilityLookup) => [
      ...prevFacilityLookup,
      ...selectedFacilities,
    ]);
    setSelectedFacilities([]);
  };

  const moveAllToSelectedSaleRep = () => {
    setSelectedSalesRep((prevSelectedSalesRep) => [
      ...prevSelectedSalesRep,
      ...salesReplookup,
    ]);
    setSalesReplookup([]);
  };

  const moveAllToDaleRepLookup = () => {
    setSalesReplookup((prevSalesReplookup) => [
      ...prevSalesReplookup,
      ...selectedSalesRep,
    ]);
    setSelectedSalesRep([]);
  };

  /*#####################-----Facility function End-----###################*/

  /*###################  SalesRep lookup & selectedSalesRep function Start ######################### */

  useEffect(() => {
    const fetchSalesRep = async () => {
      const salesRep: any = await SAlesRepLookupApi();
      setSalesReplookup(salesRep.data);
    };
    fetchSalesRep();
  }, [selectedValue]);

  const handleRepClick = (rep: Lookups) => {
    setSelectedSalesRep((prevSelectedSalesRep) => {
      if (
        prevSelectedSalesRep.some((selected) => selected.value === rep.value)
      ) {
        return prevSelectedSalesRep;
      } else {
        return [...prevSelectedSalesRep, rep];
      }
    });

    setSalesReplookup((prevSalesReplookup) =>
      prevSalesReplookup.filter((r) => r.value !== rep.value)
    );
  };

  const removeSelectedRep = (rep: Lookups) => {
    setSelectedSalesRep((prevSelectedSalesRep) =>
      prevSelectedSalesRep.filter((r) => r.value !== rep.value)
    );
    setSalesReplookup((prevSalesReplookup) => [...prevSalesReplookup, rep]);
  };
  const filteredSelectedReps = selectedSalesRep.filter((rep) =>
    rep?.label?.toLowerCase().includes(selectedRepsSearchTerm.toLowerCase())
  );

  const saleRepremoveDuplicates = (arr: Lookups[]): Lookups[] => {
    const uniqueValues = new Set<number>();
    return arr.filter((item) => {
      if (uniqueValues.has(item.value)) {
        return false;
      } else {
        uniqueValues.add(item.value);
        return true;
      }
    });
  };
  //##########  Remove duplicates from the lookup array ############
  const saleRepuniqueLookup = saleRepremoveDuplicates(salesReplookup);

  const saleReplookupForEdit = saleRepuniqueLookup.filter(
    (lookupItem: Lookups) =>
      !selectedSalesRep.some(
        (selectedItem: Lookups) => selectedItem.value === lookupItem.value
      )
  );

  const filteredAllReps = saleReplookupForEdit.filter((facility) =>
    facility.label.toLowerCase().includes(allRepsSearchTerm.toLowerCase())
  );
  /*###################  SalesRep lookup & selectedSalesRep function End ######################### */

  const handleParentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setParentChecked(checked);
    setChildChecked(childChecked.map(() => checked));
  };
  const selectlookup = [
    { value: 5, label: t("date of collection") },
    { value: 10, label: t("received date") },
    { value: 15, label: t("validated date") },
    { value: 20, label: t("rejected date") },
    { value: 25, label: t("Added date") },
  ];
  const handleChildChange =
    (index: number) => (e: React.ChangeEvent<HTMLInputElement>) => {
      const checked = e.target.checked;
      const updatedChildChecked = [...childChecked];
      updatedChildChecked[index] = checked;
      setChildChecked(updatedChildChecked);
      setParentChecked(updatedChildChecked.every(Boolean));
    };
  const [openalert, setOpenAlert] = useState(false);
  const handleCloseAlert = () => setOpenAlert(false);
  const handleClickOpen = () => setOpenAlert(true);

  const validateReportSelection = () => {
    if (selectedValue === null) return t("Select at least one option.");

    if (selectedValue === 0 && childChecked.every((val) => !val))
      return t("Select at least one checkbox.");
    if (
      selectedValue === 1 &&
      (!selectedFacilities || selectedFacilities.length === 0)
    )
      return t("Select at least one Facility.");
    if (selectedValue === 1 && childChecked.every((val) => !val))
      return t("Select at least one checkbox.");
    if (
      selectedValue === 2 &&
      (!selectedSalesRep || selectedSalesRep.length === 0)
    )
      return t("Select at least one Sales Rep.");
    if (selectedValue === 2 && childChecked.every((val) => !val))
      return t("Select at least one checkbox.");
    if (
      selectedValue === 4 &&
      (!selectedSalesGroup || selectedSalesGroup.length === 0)
    )
      return t("Select at least one Sales Group.");
    if (selectedValue === 4 && childChecked.every((val) => !val))
      return t("Select at least one checkbox.");
    if (
      selectedValue === MICRO_PERCENT_SENSITIVITIES &&
      !selectedReportFacility
    )
      return t("Select at least one Facility.");

    if (
      selectedValue === 14 &&
      (!selectedFacilities || selectedFacilities.length === 0)
    )
      return t("Select at least one Facility.");

    return null;
  };

  const handleChangeCategory = (e: any) => {
    setpostData((prevData: any) => ({
      ...prevData,
      selectLabel: e.label,
    }));
  };
  const handleChangeTestType = (e: Lookups | null) => {
    setSelectedTestType(e);
  };

  const APISENDFacility = selectedFacilities.map((value: any) => value.value);
  const APISENDSaleRep = selectedSalesRep.map((value: any) => value.value);

  // Micro Percent Sensitivities sends the one picked facility as [id]; every
  // other report keeps sending the dual list selection
  const facilityIdsForReport =
    selectedValue === MICRO_PERCENT_SENSITIVITIES
      ? selectedReportFacility
        ? [selectedReportFacility.value]
        : []
      : APISENDFacility || [];

  /*#####################-----Scheduled Report API Start-----###################*/

  const DAY_NAME_TO_DOTNET: Record<string, number> = {
    Sunday: 0,
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
  };

  const DATA_RANGE_TO_API: Record<string, string> = {
    Yesterday: "yesterday",
    "Yesterday to Date": "yesterdaytodate",
    "Last 7 Days to Date": "last7daystodate",
    "Week to Date": "weektodate",
    "Last Week": "lastweek",
    "Month to Date": "monthtodate",
    "Last Month": "lastmonth",
    "Last 30 Days": "last30days",
    "Year to Date": "yeartodate",
  };

  const to24Hour = (hour: number, meridiem: "AM" | "PM") => {
    const base = hour % 12;
    return meridiem === "PM" ? base + 12 : base;
  };

  const PostApiData = async (config: ScheduleConfig) => {
    const hour24 = to24Hour(config.hour, config.meridiem);
    const hh = String(hour24).padStart(2, "0");
    const mm = String(config.minute).padStart(2, "0");

    // The modal collects browser-local values; the API receives them as UTC.
    const scheduledUtc = convertBrowserDateTimeToUtc(
      config.beginDate,
      `${hh}:${mm}:00`
    );
    const beginDateUtc = convertBrowserDateTimeToUtc(config.beginDate);
    const endDateUtc = convertBrowserDateTimeToUtc(config.endDate);

    if (!scheduledUtc || !beginDateUtc || !endDateUtc) {
      throw new Error("Invalid schedule date or time");
    }

    const selectedDays =
      config.frequency === "Daily"
        ? config.daysOfWeek.map((day) => DAY_NAME_TO_DOTNET[day])
        : [];

    const weeklyDay =
      config.frequency === "Weekly" && config.dayOfWeek
        ? DAY_NAME_TO_DOTNET[config.dayOfWeek]
        : 0;

    const monthlyDay =
      config.frequency === "Monthly" && config.dayOfMonth !== null
        ? config.dayOfMonth
        : 0;

    const data = {
      id: postData.id,
      reportName: config.name,
      frequency: config.frequency,
      scheduledDate: scheduledUtc.toISOString(),
      facilityIds: facilityIdsForReport?.length ? facilityIdsForReport : [],
      salesRepIds: (APISENDSaleRep || []).map((id: number | string) =>
        String(id)
      ),
      reportDataArray: {
        patientFirstName: childChecked?.[0],
        patientLastName: childChecked?.[1],
        patientDateOfBirth: childChecked?.[2],
        patientID: childChecked?.[3],
        patientGender: childChecked?.[4],
        patientAddress: childChecked?.[5],
        patientCity: childChecked?.[6],
        patientState: childChecked?.[7],
        patientZipCode: childChecked?.[8],
        patientEmail: childChecked?.[9],
        requisitionType: childChecked?.[10],
        resultDelivery: childChecked?.[40],
        dateOfCollection: childChecked?.[11],
        timeOfCollection: childChecked?.[12],
        recievedDate: childChecked?.[13],
        validatedDate: childChecked?.[14],
        rejectedDate: childChecked?.[15],
        rejectedReason: childChecked?.[16],
        status: childChecked?.[17],
        accessionNo: childChecked?.[18],
        insuranceType: childChecked?.[19],
        labCode: childChecked?.[20],
        referenceLab: childChecked?.[21],
        pharmD: childChecked?.[22],
        panelName: childChecked?.[23],
        providerName: childChecked?.[26],
        groupID: childChecked?.[27],
        relationshipToInsure: childChecked?.[28],
        policyID: childChecked?.[29],
        policyHolderDOB: childChecked?.[30],
        facilityName: childChecked?.[31],
        facilityAddress: childChecked?.[32],
        facilityCity: childChecked?.[33],
        facilityState: childChecked?.[34],
        facilityZipCode: childChecked?.[35],
        facilityID: childChecked?.[36],
        physicianName: childChecked?.[37],
        npi: childChecked?.[38],
        saleRepName: childChecked?.[39],
        saleGroupName: childChecked?.[41],
        positivePathogens: childChecked?.[24] ?? false,
        dxCodes: childChecked?.[25],
      },
      reportType:
        selectedValue === MICRO_PERCENT_SENSITIVITIES
          ? REPORT_TYPE_NAME.MicroPercentSensitivitiesReport
          : (config.filterType?.label ?? ""),
      reportBy: selectedValue,
      testType: selectedTestType?.value ?? null,
      isDeleted: false,
      beginDate: beginDateUtc.toISOString(),
      endDate: endDateUtc.toISOString(),
      scheduleTime: formatUtcTimeForApi(scheduledUtc),
      dataRangeType: DATA_RANGE_TO_API[config.dataRange] ?? config.dataRange,
      selectedDays,
      weeklyDay,
      monthlyDay,
    };

    try {
      const resp = await RequisitionReportSave(data);
      return resp;
    } catch {
      throw new Error("Error while saving data");
    }
  };

  const handleScheduleSave = async (config: ScheduleConfig) => {
    const reportError = validateReportSelection();
    if (reportError) {
      toast.error(reportError);
      return;
    }

    setButtonDisable(true);
    try {
      const resp = await PostApiData(config);
      if (resp.data.statusCode === 200) {
        toast.success("Request Processed Successfully...");
        resetState();
      } else if (resp.data.statusCode === 400) {
        toast.error(
          resp.data.message || t("An error occurred. Please try again.")
        );
      } else {
        toast.error(t("An unexpected error occurred."));
      }
    } catch {
      toast.error(t("An error occurred while saving data."));
    } finally {
      setButtonDisable(false);
    }
  };

  const resetState = () => {
    setFilterData({});
    setOpenAlert(false);
    setSelectedSalesGroup([]);
    // setShowSaleGroup(false);
    // setShowSaleRep(false);
    // setShowFacility(false);
    // setMonthlyPositively(false);
    // setTATReport(false);
    setParentChecked(false);
    setpostData(initialPostData);
    setChildChecked(Array(42).fill(false));
    setSelectedTestType(null);
    setSelectedReportFacility(null);
  };

  /*#####################-----Scheduled Report Download API Start-----###################*/

  const handleDownload = async () => {
    const validateDownload = () => {
      const reportError = validateReportSelection();
      if (reportError) return reportError;

      // if (selectedValue === 7 && (!selectedFacilities || selectedFacilities.length === 0))
      //   return t("Select at least one Facility.");

      if (Object.keys(filterData).length === 0) {
        return t("Please Enter Date.");
      }
      // Micro Percent Sensitivities filters on Facility and the collection date
      // range only — it has no Date type picker to validate
      if (selectedValue === MICRO_PERCENT_SENSITIVITIES || selectedValue === 14) return null;
      // Daily Sample Volume hides "Select Data" but still filters on Date type
      if (
        (!isNamedReport(selectedValue) ||
          selectedValue === DAILY_SAMPLE_VOLUME_REPORT) &&
        !postData.selectLabel?.trim())
        return t("Please select any data field.");
      // if (selectedValue !== 7 && !postData.selectLabel?.trim())
      //   return t("Please select any data field.");

      if ((selectedValue === REQUISITION_BILLING ||
        selectedValue === DAILY_SAMPLE_VOLUME_REPORT) && selectedTestType === null)
        return t("Please select Test type.");

      return null;
    };
    const errorMessage = validateDownload();
    if (errorMessage) {
      toast.error(errorMessage);
      return;
    }

    // One card carries the whole request: it starts as a spinner and turns into
    // the queued confirmation, so the click is never left without feedback
    const noticeStartedAt = Date.now();
    const noticeId = pushReportNotice({
      status: "pending",
      title: t("Adding report to queue..."),
      autoCloseMs: null,
    });

    // The picked days are lab-timezone days; the API receives them as UTC.
    // Without a lab timezone the picked value is sent unchanged.
    const toUtcFilterDate = (value: string) =>
      convertLabDateTimeToUtc(value, undefined, labTimeZone)?.toISOString() ??
      value;

    try {
      const obj = {
        reportBy: selectedValue,
        facilityIds: facilityIdsForReport,
        salesRepIds: APISENDSaleRep || [],
        salesGroupIds: APISENDSaleGroup || [],
        reportData: {
          patientFirstName: childChecked?.[0],
          patientLastName: childChecked?.[1],
          patientDateOfBirth: childChecked?.[2],
          patientID: childChecked?.[3],
          patientGender: childChecked?.[4],
          patientAddress: childChecked?.[5],
          patientCity: childChecked?.[6],
          patientState: childChecked?.[7],
          patientZipCode: childChecked?.[8],
          patientEmail: childChecked?.[9],
          requisitionType: childChecked?.[10],
          resultDelivery: childChecked?.[40],
          dateOfCollection: childChecked?.[11],
          timeOfCollection: childChecked?.[12],
          recievedDate: childChecked?.[13],
          validatedDate: childChecked?.[14],
          rejectedDate: childChecked?.[15],
          rejectedReason: childChecked?.[16],
          status: childChecked?.[17],
          accessionNo: childChecked?.[18],
          insuranceType: childChecked?.[19],
          labCode: childChecked?.[20],
          referenceLab: childChecked?.[21],
          pharmD: childChecked?.[22],
          panelName: childChecked?.[23],
          providerName: childChecked?.[26],
          groupID: childChecked?.[27],
          relationshipToInsure: childChecked?.[28],
          policyID: childChecked?.[29],
          policyHolderDOB: childChecked?.[30],
          facilityName: childChecked?.[31],
          facilityAddress: childChecked?.[32],
          facilityCity: childChecked?.[33],
          facilityState: childChecked?.[34],
          facilityZipCode: childChecked?.[35],
          facilityID: childChecked?.[36],
          physicianName: childChecked?.[37],
          npi: childChecked?.[38],
          saleRepName: childChecked?.[39],
          saleGroupName: childChecked?.[41],
          positivePathogens: childChecked?.[24] ?? false,
          dxCodes: childChecked?.[25],
          ...(selectedValue === DAILY_SAMPLE_VOLUME_REPORT && {
            Clinic: selectedClinic.label,
            Panel: selectedPanel.label,
          }),
        },
        dateFrom: toUtcFilterDate(filterData.dateFrom),
        dateTo: toUtcFilterDate(filterData.dateTo),
        // Pending Requisition List filters on its own Requisition Type, every
        // other report on the Test type picker
        reqTypeId:
          selectedValue === PENDING_REQUISITION_LIST
            ? (selectedRequisitionType?.value ?? allRequisitionTypes.value)
            : (selectedTestType?.value ?? null),
        reportType:
          REPORT_BY_TO_REPORT_TYPE[selectedValue as number] ??
          postData.selectLabel,
        // Order Type travels as labId — the reference lab id, or 0 for All Orders
        labId:
          selectedValue === PENDING_REQUISITION_LIST
            ? (selectedOrderType?.value ?? allOrders.value)
            : 0,
      };
      // GenerateReportV2 only queues the report — a notification arrives once
      // it is ready, so there is no file to hand back here.
      const res = await GenerateReportV2(obj);
      if (res.data.statusCode === 200) {
        // Lets the notification handler announce the finished report
        markReportQueued();
        resetDownloadState();

        const pendingShownFor = Date.now() - noticeStartedAt;
        if (pendingShownFor < PENDING_NOTICE_MIN_MS) {
          await new Promise((resolve) =>
            setTimeout(resolve, PENDING_NOTICE_MIN_MS - pendingShownFor)
          );
        }

        updateReportNotice(noticeId, {
          status: "queued",
          title: (res.data.message || t("Report added to queue")).replace(
            /\.\s*$/,
            ""
          ),
          message: t("we will let you know once it is ready."),
          autoCloseMs: QUEUED_NOTICE_AUTO_CLOSE_MS,
        });
      } else {
        updateReportNotice(noticeId, {
          status: "error",
          title:
            (res.data.statusCode === 400 && res.data.message) ||
            t("An error occurred while generating the report."),
          autoCloseMs: ERROR_NOTICE_AUTO_CLOSE_MS,
        });
      }
    } catch {
      updateReportNotice(noticeId, {
        status: "error",
        title: t("An error occurred while generating the report."),
        autoCloseMs: ERROR_NOTICE_AUTO_CLOSE_MS,
      });
    }
  };

  const resetDownloadState = () => {
    setFilterData({});
    // setShowSaleRep(false);
    // setShowSaleGroup(false);
    // setShowFacility(false);
    // setMonthlyPositively(false);
    // setTATReport(false);
    setParentChecked(false);
    setSelectedSalesRep([]);
    setSelectedSalesGroup([]);
    setSelectedFacilities([]);
    setpostData(initialPostData);
    setChildChecked(Array(42).fill(false));
    setSelectedTestType(null);
    setSelectedRequisitionType(null);
    setSelectedOrderType(null);
    setSelectedReportFacility(null);
  };

  const handleRadioChange = (value: number) => {
    setSelectedValue(value);
    setSelectedTestType(null);
    // Pending Requisition List keeps its own filters, cleared with the report
    setSelectedRequisitionType(null);
    setSelectedOrderType(null);
    setSelectedReportFacility(null);

    switch (value) {
      case 0:
        // setStewardReport(false);
        setBillingReport(false);
        setShowSaleRep(false);
        setShowFacility(false);
        setShowSaleGroup(false);
        setSelectedSalesRep([]);
        setSelectedFacilities([]);
        setMonthlyPositively(false);
        setTATReport(false);
        break;
      case 1:
        // setStewardReport(false);
        setBillingReport(false);
        setShowSaleRep(false);
        setShowSaleGroup(false);
        setShowFacility(true);
        setSelectedSalesRep([]);
        setMonthlyPositively(false);
        setTATReport(false);
        break;
      case 2:
        // setStewardReport(false);
        setBillingReport(false);
        setShowSaleRep(true);
        setShowSaleGroup(false);
        setShowFacility(false);
        setSelectedFacilities([]);
        setMonthlyPositively(false);
        setTATReport(false);
        break;
      // sales group case
      case 4:
        // setStewardReport(false);
        setBillingReport(false);
        setShowSaleGroup(true);
        setShowFacility(false);
        setShowSaleRep(false);
        setSelectedFacilities([]);
        setMonthlyPositively(false);
        setTATReport(false);
        break;

      case 3:
        // setStewardReport(false);
        setBillingReport(false);
        setShowSaleRep(false);
        setShowFacility(false);
        setShowSaleGroup(false);
        setSelectedSalesRep([]);
        setSelectedFacilities([]);
        setMonthlyPositively(true);
        setChildChecked(Array(42).fill(false));
        setTATReport(false);
        break;
      case 5:
        // setStewardReport(false);
        setBillingReport(true);
        setShowSaleGroup(false);
        setShowFacility(false);
        setShowSaleRep(false);
        setSelectedFacilities([]);
        setMonthlyPositively(false);
        setTATReport(false);
        break;
      case 6:
        // setStewardReport(false);
        setBillingReport(false);
        setTATReport(true);
        setShowSaleGroup(false);
        setShowFacility(false);
        setShowSaleRep(false);
        setSelectedFacilities([]);
        setMonthlyPositively(false);
        break;
      // case 7:
      //   setStewardReport(true);
      //   setpostData((prevData: any) => ({
      //     ...prevData,
      //     selectLabel: "",
      //   }));
      //   setBillingReport(false);
      //   setTATReport(false);
      //   setShowSaleGroup(false);
      //   setShowFacility(false);
      //   setShowSaleRep(false);
      //   setSelectedFacilities([]);
      //   setMonthlyPositively(false);
      //   break;
      case 7:
        // setStewardReport(false);
        setBillingReport(false);
        setTATReport(false);
        setShowSaleGroup(false);
        setShowFacility(false);
        setShowSaleRep(false);
        setSelectedFacilities([]);
        setSelectedSalesRep([]);
        setMonthlyPositively(false);
        setChildChecked(Array(42).fill(false));
        break;
      case 8:
      case 9:
      case 10:
      case MICRO_PERCENT_SENSITIVITIES:
        setBillingReport(false);
        setTATReport(false);
        setShowSaleGroup(false);
        setShowFacility(false);
        setShowSaleRep(false);
        setSelectedFacilities([]);
        setSelectedSalesRep([]);
        setMonthlyPositively(false);
        setChildChecked(Array(42).fill(false));
        break;
      case NOT_RECEIVED_REPORT:
        setBillingReport(false);
        setTATReport(false);
        setShowSaleGroup(false);
        setShowFacility(false);
        setShowSaleRep(false);
        setSelectedFacilities([]);
        setSelectedSalesRep([]);
        setMonthlyPositively(false);
        setChildChecked(Array(42).fill(false));
        break;

      case 14:
        setBillingReport(false);
        setTATReport(false);
        setShowSaleGroup(false);
        setShowFacility(true);
        setShowSaleRep(false);
        setSelectedFacilities([]);
        setSelectedSalesRep([]);
        setMonthlyPositively(false);
        setChildChecked(Array(42).fill(false));
        break;

      case 16:// Daily Sample Volume Report
      case IGNITEABX_REPORT_EXPORT: 
        setBillingReport(false);
        setTATReport(false);
        setShowSaleGroup(false);
        setShowFacility(false);
        setShowSaleRep(false);
        setSelectedFacilities([]);
        setSelectedSalesRep([]);
        setMonthlyPositively(false);
        setChildChecked(Array(42).fill(false));
        break;

      case 17:
        setBillingReport(false);
        setTATReport(false);
        setShowSaleGroup(false);
        setShowFacility(false);
        setShowSaleRep(false);
        setSelectedFacilities([]);
        setSelectedSalesRep([]);
        setMonthlyPositively(false);
        setChildChecked(Array(42).fill(false));
        break;
      case 18:
        setSelectedSalesGroup([]);
        setMonthlyPositively(false);
        setChildChecked(Array(42).fill(false));
        setpostData(initialPostData);
        break;

      default:
        // setStewardReport(false);
        setShowSaleRep(false);
        setShowFacility(false);
        setBillingReport(false);
        setShowSaleGroup(false);
        setSelectedSalesRep([]);
        setSelectedFacilities([]);
        setMonthlyPositively(false);
        setTATReport(false);
        break;
    }
  };

  /*############        Sales Group UI ##################*/

  const [salesGrouplookup, setSalesGrouplookup] = useState<Lookups[]>([]);
  const [showSaleGroup, setShowSaleGroup] = useState(false);
  const [selectedSalesGroup, setSelectedSalesGroup] = useState<Lookups[]>([]);
  const [allGroupSearchTerm, setAllGroupSearchTerm] = useState("");
  const [selectedGroupSearchTerm, setSelectedGroupSearchTerm] = useState("");

  const APISENDSaleGroup = selectedSalesGroup.map((value: any) => value.value);

  useEffect(() => {
    const fetchSalesGroup = async () => {
      const payload = {
        requestModel: {
          isActive: true,
        },
      };

      try {
        const salesGroup: any = await SalesGroupGetAll(payload);

        // Add defensive checks for null/undefined data
        const result = salesGroup?.data?.result;

        if (!result || !Array.isArray(result) || result.length === 0) {
          console.log("No sales groups found");
          setSalesGrouplookup([]);
          return;
        }

        // Transform the API response to match Lookups interface
        const transformedData = result
          .filter((group: any) => group && group.id && group.name) // Filter out invalid entries
          .map((group: any) => ({
            value: group.id,
            label: group.name,
          }));

        setSalesGrouplookup(transformedData);
        console.log("transformed sales group lookup", transformedData);
      } catch (error) {
        console.error("Error fetching sales groups:", error);
        setSalesGrouplookup([]); // Set empty array on error
      }
    };

    fetchSalesGroup();
  }, [selectedValue]);

  const handleGroupClick = (rep: Lookups) => {
    setSelectedSalesGroup((prevSelectedSalesGroup) => {
      if (
        prevSelectedSalesGroup.some((selected) => selected.value === rep.value)
      ) {
        return prevSelectedSalesGroup.filter((r) => r.value !== rep.value);
      } else {
        return [...prevSelectedSalesGroup, rep];
      }
    });

    setSalesReplookup((prevSalesReplookup) =>
      prevSalesReplookup.filter((r) => r.value !== rep.value)
    );
  };

  // For filtering selected groups
  // const filteredSelectedGroups = selectedSalesGroup.filter((group) => {
  //   const label = group?.label || "";
  //   const searchTerm = selectedGroupSearchTerm || "";
  //   return label.toLowerCase().includes(searchTerm.toLowerCase());
  // });

  // For filtering selected groups - add null checks
  const filteredSelectedGroups = selectedSalesGroup.filter((group) => {
    if (!group || !group.label) return false; // Add this check
    const label = group.label || "";
    const searchTerm = selectedGroupSearchTerm || "";
    return label.toLowerCase().includes(searchTerm.toLowerCase());
  });

  const removeSelectedGroups = (rep: Lookups) => {
    setSelectedSalesGroup((prevSelectedSalesGroup) =>
      prevSelectedSalesGroup.filter((r) => r.value !== rep.value)
    );
    setSalesGrouplookup((prevSalesGrouplookup) => [
      ...prevSalesGrouplookup,
      rep,
    ]);
  };

  const saleGroupremoveDuplicates = (arr: Lookups[]): Lookups[] => {
    const uniqueValues = new Set<number>();
    return arr.filter((item) => {
      if (uniqueValues.has(item.value)) {
        return false;
      } else {
        uniqueValues.add(item.value);
        return true;
      }
    });
  };
  //##########  Remove duplicates from the lookup array ############
  const saleGroupuniqueLookup = saleGroupremoveDuplicates(salesGrouplookup);

  const saleGrouplookupForEdit = saleGroupuniqueLookup.filter(
    (lookupItem: Lookups) =>
      !selectedSalesGroup.some(
        (selectedItem: Lookups) => selectedItem.value === lookupItem.value
      )
  );

  // For filtering all groups - add null checks
  const filteredAllGroups = saleGrouplookupForEdit.filter((group) => {
    if (!group || !group.label) return false; // Add this check
    const label = group.label || "";
    const searchTerm = allGroupSearchTerm || "";
    return label.toLowerCase().includes(searchTerm.toLowerCase());
  });

  // // For filtering all groups
  // const filteredAllGroups = saleGrouplookupForEdit.filter((group) => {
  //   const label = group?.label || "";
  //   const searchTerm = allGroupSearchTerm || "";
  //   return label.toLowerCase().includes(searchTerm.toLowerCase());
  // });

  const moveAllToSelectedSalesGroupLookup = () => {
    setSelectedSalesGroup((prevSelectedSalesGroup) => [
      ...prevSelectedSalesGroup,
      ...salesGrouplookup,
    ]);
    setSalesGrouplookup([]);
  };

  const moveAllToSalesGroupLookup = () => {
    setSalesGrouplookup((prevSalesGrouplookup) => [
      ...prevSalesGrouplookup,
      ...selectedSalesGroup,
    ]);
    setSelectedSalesGroup([]);
  };

  return (
    <>
      <div className="card">
        <div className="row card-header px-0">
          <div className="card-heading ">
            <h6 className="required">{t("Select Report")}</h6>
          </div>
          <div className="row">
            <div className="col-sm-12 pt-4 pb-2">
              {/* gap keeps the wrapped second row aligned left instead of
                  justify-content-between stretching it across the card */}
              <div className="d-flex flex-wrap gap-4">
                {radioValues.map((radVal, index) => {
                  const uniqueId = `radio-${radVal.value}-${index}`;
                  return (
                    <div key={radVal.value}>
                      <label
                        className="form-check form-check-sm form-check-solid w-fit-content"
                        style={{ width: "fit-content" }}
                        htmlFor={uniqueId}
                      >
                        {" "}
                        <input
                          id={uniqueId}
                          className="form-check-input h-20px w-20px rounded-4"
                          type="radio"
                          value={radVal.value}
                          name="resultType"
                          checked={selectedValue === radVal.value}
                          onChange={() => handleRadioChange(radVal.value)}
                        />
                        {radVal.label}
                      </label>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        {showFacility ? (
          <ByFacility
            handleFacilityClick={handleFacilityClick}
            filteredAllFacilities={filteredAllFacilities}
            allFacilitiesSearchTerm={allFacilitiesSearchTerm}
            moveAllToFacilityLookup={moveAllToFacilityLookup}
            removeSelectedFacilities={removeSelectedFacilities}
            filteredSelectedFacilities={filteredSelectedFacilities}
            setAllFacilitiesSearchTerm={setAllFacilitiesSearchTerm}
            moveAllToSelectedFacilities={moveAllToSelectedFacilities}
            selectedFacilitiesSearchTerm={selectedFacilitiesSearchTerm}
            setSelectedFacilitiesSearchTerm={setSelectedFacilitiesSearchTerm}
          />
        ) : null}
        {showSaleRep ? (
          <BySaleRep
            handleRepClick={handleRepClick}
            filteredAllReps={filteredAllReps}
            allRepsSearchTerm={allRepsSearchTerm}
            removeSelectedRep={removeSelectedRep}
            filteredSelectedReps={filteredSelectedReps}
            setAllRepsSearchTerm={setAllRepsSearchTerm}
            selectedRepsSearchTerm={selectedRepsSearchTerm}
            moveAllToFacilityLookup={moveAllToDaleRepLookup}
            moveAllToSelectedFacilities={moveAllToSelectedSaleRep}
            setSelectedSalesRepsSearchTerm={setSelectedSalesRepsSearchTerm}
          />
        ) : null}

        {showSaleGroup ? (
          <BySalesGroup
            handleGroupClick={handleGroupClick}
            filteredAllGroups={filteredAllGroups}
            allGroupSearchTerm={allGroupSearchTerm}
            removeSelectedGroups={removeSelectedGroups}
            filteredSelectedGroups={filteredSelectedGroups}
            setAllGroupSearchTerm={setAllGroupSearchTerm}
            selectedGroupSearchTerm={selectedGroupSearchTerm}
            moveAllToSalesGroupLookup={moveAllToSalesGroupLookup}
            moveAllToSelectedSalesGroupLookup={
              moveAllToSelectedSalesGroupLookup
            }
            setSelectedGroupSearchTerm={setSelectedGroupSearchTerm}
          />
        ) : null}

        {!hasFixedReportColumns(selectedValue) &&
  !isNamedReport(selectedValue) &&
  selectedValue !== IGNITEABX_REPORT_EXPORT &&
  selectedValue !== NOT_RECEIVED_REPORT &&
  (monthlyPositively ? (
            <MonthlyPositively />
          ) : billingReport ? (
            <BillingReport />
          ) : tatReport ? (
            <TATReport />
          ) : (
            // ) : stewardReport ? (
            //   <>
            //     <StewardReport />
            //     <ByFacility
            //       handleFacilityClick={handleFacilityClick}
            //       filteredAllFacilities={filteredAllFacilities}
            //       allFacilitiesSearchTerm={allFacilitiesSearchTerm}
            //       moveAllToFacilityLookup={moveAllToFacilityLookup}
            //       removeSelectedFacilities={removeSelectedFacilities}
            //       filteredSelectedFacilities={filteredSelectedFacilities}
            //       setAllFacilitiesSearchTerm={setAllFacilitiesSearchTerm}
            //       moveAllToSelectedFacilities={moveAllToSelectedFacilities}
            //       selectedFacilitiesSearchTerm={selectedFacilitiesSearchTerm}
            //       setSelectedFacilitiesSearchTerm={setSelectedFacilitiesSearchTerm}
            //     />
            //   </>
            // ) : (
            <div className="row card-body px-0 py-3">
              <div className="card-heading">
                <h6>{t("Select Data")}</h6>
                <label className="form-check form-check-sm form-check-solid">
                  <input
                    id="CheckAllCheckBox"
                    name="urgent"
                    className="form-check-input h-20px w-20px"
                    type="checkbox"
                    checked={parentChecked}
                    onChange={handleParentChange}
                  />
                  {t("Check All")}
                </label>
              </div>
              <CheckBox
                childChecked={childChecked}
                handleChildChange={handleChildChange}
              />
            </div>
          ))}
      </div>
      <div className="card-footer px-0 pt-2 pb-0">
        <div className="card-heading">
          <h6>{t("Filter")}</h6>
        </div>

        <div className="d-flex flex-wrap justify-content-start align-items-end mb-2 gap-2">
          <div className="d-flex align-items-end flex-wrap gap-2">
            <div className="d-flex flex-column">
              <span className="fw-400 mb-1">
                {selectedValue === MICRO_PERCENT_SENSITIVITIES
                  ? t("Collection Date Range")
                  : t("Date")}
              </span>
              <DateAndTimeDuplicate
                setFilterData={setFilterData}
                filterData={filterData}
              />
            </div>
            {selectedValue === MICRO_PERCENT_SENSITIVITIES ? (
              <div className="d-flex flex-column">
                <span className="fw-400 mb-1 required">{t("Facility")}</span>
                <Select
                  inputId="RequisitionReportFacility"
                  menuPortalTarget={document.body}
                  styles={reactSelectSMStyle}
                  theme={(theme: any) => styles(theme)}
                  options={uniqueLookup}
                  placeholder={t("Select...")}
                  name="facility"
                  onChange={(option: Lookups | null) =>
                    setSelectedReportFacility(option)
                  }
                  value={selectedReportFacility}
                  isClearable
                />
              </div>
            ) : (
              selectedValue !== 14 && (
                <div className="d-flex flex-column">
                  <span className="fw-400 mb-1">{t("Date type")}</span>
                  <Select
                    inputId="RequisitionReportCategory"
                    menuPortalTarget={document.body}
                    styles={reactSelectSMStyle}
                    theme={(theme: any) => styles(theme)}
                    options={selectlookup}
                    placeholder={t("Select...")}
                    name="selectLabel"
                    onChange={handleChangeCategory}
                    value={
                      selectlookup.find(
                        (option) => option.label === postData.selectLabel
                      ) || null
                    }
                  />
                </div>
              )
            )}
            {/* {selectedValue !== 7 && (
              <div className="d-flex flex-column">...</div>
            )} */}
            {(selectedValue === REQUISITION_BILLING ||
              selectedValue === DAILY_SAMPLE_VOLUME_REPORT
            ) && (
                <div className="d-flex flex-column">
                  <span className="fw-400 mb-1">{t("Test type")}</span>
                  <Select
                    inputId="RequisitionReportTestType"
                    menuPortalTarget={document.body}
                    styles={reactSelectSMStyle}
                    theme={(theme: any) => styles(theme)}
                    options={testTypeLookup}
                    placeholder={t("Select...")}
                    name="testType"
                    onChange={handleChangeTestType}
                    value={selectedTestType}
                    isClearable
                  />
                </div>
              )}
            {selectedValue === PENDING_REQUISITION_LIST && (
              <>
                <div className="d-flex flex-column">
                  <span className="fw-400 mb-1">{t("Requisition Type")}</span>
                  <Select
                    inputId="RequisitionReportRequisitionType"
                    menuPortalTarget={document.body}
                    styles={reactSelectSMStyle}
                    theme={(theme: any) => styles(theme)}
                    options={requisitionTypeOptions}
                    placeholder={t("Select...")}
                    name="requisitionType"
                    onChange={(option: Lookups | null) =>
                      setSelectedRequisitionType(option)
                    }
                    value={selectedRequisitionType ?? allRequisitionTypes}
                  />
                </div>
                <div className="d-flex flex-column">
                  <span className="fw-400 mb-1">{t("Order Type")}</span>
                  <Select
                    inputId="RequisitionReportOrderType"
                    menuPortalTarget={document.body}
                    styles={reactSelectSMStyle}
                    theme={(theme: any) => styles(theme)}
                    options={orderTypeOptions}
                    placeholder={t("Select...")}
                    name="orderType"
                    onChange={(option: Lookups | null) =>
                      setSelectedOrderType(option)
                    }
                    value={selectedOrderType ?? allOrders}
                  />
                </div>
              </>
            )}
            {selectedValue === DAILY_SAMPLE_VOLUME_REPORT && (
              <>
                <div className="d-flex flex-column">
                  <span className="fw-400 mb-1">{t("Clinics")}</span>
                  <Select
                    inputId="DailySampleVolumeClinic"
                    menuPortalTarget={document.body}
                    styles={reactSelectSMStyle}
                    theme={(theme: any) => styles(theme)}
                    options={[allClinics]}
                    value={selectedClinic}
                    onChange={(option: Lookups | null) =>
                      setSelectedClinic(option ?? allClinics)
                    }
                    isClearable={false}
                  />
                </div>

                <div className="d-flex flex-column">
                  <span className="fw-400 mb-1">{t("Panels")}</span>
                  <Select
                    inputId="DailySampleVolumePanel"
                    menuPortalTarget={document.body}
                    styles={reactSelectSMStyle}
                    theme={(theme: any) => styles(theme)}
                    options={[allPanels, ...panelLookup]}
                    value={selectedPanel}
                    onChange={(option: Lookups | null) =>
                      setSelectedPanel(option ?? allPanels)
                    }
                    isClearable={false}
                  />
                </div>
              </>
            )}
          </div>
          <button
            id="RequisitionReportDownloadReports"
            type="button"
            className="btn btn-warning btn-sm fw-bold"
            onClick={handleDownload}
          >
            {t("Download Report")}
          </button>
        </div>
      </div>
      {selectedValue !== DAILY_SAMPLE_VOLUME_REPORT && (
        <div className="card-footer px-0 pt-2 pb-0">
          <div className="d-flex gap-2 align-items-center">
            <h6>Schedule Report</h6>
            <p className="text-danger fw-semibold mb-3 fst-italic">
              {t("(Please click below if you want to schedule a report)")}
            </p>
          </div>
          <button
            id="RequisitionReportScheduleReports"
            type="button"
            className="btn btn-info btn-sm fw-bold"
            onClick={handleClickOpen}
          >
            {t("Schedule Reports")}
          </button>
        </div>
      )}
      <ScheduleReportModal
        show={openalert}
        saving={buttonDisable}
        filterOptions={selectlookup}
        initialFilterLabel={postData.selectLabel}
        onHide={handleCloseAlert}
        onSave={handleScheduleSave}
      />
    </>
  );
};

export default ReqReport;
